module.exports = __webpack_public_path__ + "static/media/04.9ca1a59d.jpg";